$().ready(function () {
  
$('.sizebox').on('input',function(){
  var lgt = $("#lgt").val(),wdt = $("#wdt").val();
  console.log(lgt,wdt);
  var dty;

  var lm = lgt*0.3048;
  var wm = wdt*0.3048;

  var sqm = (lm*wm).toFixed(3);
  var sqft = (lgt*wdt).toFixed(3);

  var gl = Math.ceil(lm/0.5), gw = Math.ceil(wm/0.5);
  var grids = gl*gw;
  var coverage = (grids/4).toFixed(2);

  $('#sqft').html(sqft);
  $('#sqm').html(sqm);
  $('#grids').html(grids);
  $('#coverage').html(coverage);
  $('input[name="quantity"]').val(grids);
});

  $('.atb').click(function(){
    $('.product-form__cart-submit').trigger('click');
  });
});
